module.exports = fox._r("images/lang/it.png", __webpack_public_path__ + "_/_/_/common/frame/images/lang/it.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/images/lang/it.png
// module id = 110
// module chunks = 2